import { GitCompareArrows, History, PenLine, ScanSearch } from 'lucide-react';
import type { FeatureContent } from './types';

export const revisioneConfronto: FeatureContent = {
  slug: 'revisione-confronto',
  navLabel: 'Revisione e confronto',
  menuDescription:
    'Rivedi i documenti creati con Trovanorma, genera nuove versioni e confronta le modifiche riga per riga.',
  cardDescription:
    'Continua a lavorare sui documenti creati con Trovanorma, genera nuove versioni e confronta riga per riga ciò che cambia.',
  meta: {
    title: 'Revisione e confronto di documenti con AI',
    description:
      'Rivedi un documento generato con Trovanorma, crea nuove versioni senza perdere le precedenti e confronta le modifiche riga per riga fino alla versione definitiva.',
  },
  hero: {
    title: 'Revisione e confronto',
    subtitle:
      'Carica un documento su cui hai già lavorato. Trovanorma lo rilegge, individua i passaggi da chiarire o rafforzare e propone una versione rivista. Continui a migliorarla, confronti le versioni e arrivi al testo definitivo mantenendo il controllo su ogni modifica.',
  },
  statement: 'Il tuo lavoro è il punto di partenza',
  statementText:
    'Trovanorma parte dal testo che hai già preparato: lo analizza, suggerisce dove intervenire e ti permette di sviluppare versioni successive senza perdere il lavoro fatto.',
  blocks: [
    {
      icon: ScanSearch,
      kicker: 'Seconda lettura',
      title: 'Un altro paio d’occhi sul tuo lavoro',
      description:
        'Carica il documento e chiedi a Trovanorma di rileggerlo: individua passaggi da chiarire, approfondire o rafforzare e segnala gli elementi che meritano un’ulteriore verifica.',
    },
    {
      icon: PenLine,
      kicker: 'Proposte di modifica',
      title: 'Non solo osservazioni: una versione rivista',
      description:
        'Trovanorma può integrare, riscrivere o approfondire i punti su cui vuoi intervenire e proporti una nuova versione del documento da valutare.',
    },
    {
      icon: History,
      kicker: 'Revisioni successive',
      title: 'Miglioralo un passaggio alla volta',
      description:
        'Chiedi modifiche e approfondimenti sullo stesso documento. Ogni revisione diventa una nuova versione, senza perdere quelle precedenti.',
    },
    {
      icon: GitCompareArrows,
      kicker: 'Confronto e versione finale',
      title: 'Vedi cosa è cambiato. Decidi cosa tenere.',
      description:
        'Confronta le versioni riga per riga, verifica aggiunte, modifiche e rimozioni e scegli il testo su cui continuare fino alla versione definitiva.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Porta il tuo documento',
      description:
        'Carica una bozza, un atto, un contratto, un parere o un altro testo su cui hai già lavorato.',
    },
    {
      step: 2,
      title: 'Ricevi una revisione',
      description:
        'Trovanorma analizza il documento, evidenzia i punti da migliorare e può proporti una nuova versione con le modifiche richieste.',
    },
    {
      step: 3,
      title: 'Itera fino alla versione finale',
      description:
        'Continua a perfezionare il testo, confronta le versioni e scegli quali modifiche mantenere nel documento definitivo.',
    },
  ],
  relatedSolutions: ['studi-legali', 'avvocati', 'commercialisti'],
  closing: {
    title: 'Porta il documento su cui stai già lavorando',
    text: 'Caricalo in Trovanorma, ricevi una proposta di revisione e continua a migliorarlo per versioni successive fino al testo finale.',
  },
};
